import { useEffect, FC, useState } from "react";
import Routes from "./routes";

import { useAppDispatch } from "./store";
import { ThemeProvider } from "./providers";
import * as signalR from "@microsoft/signalr";
import "./App.css";
import { getAppointment } from "./store/appointment/thunk";
import { Amplify } from 'aws-amplify';


const App: FC = () => {

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID ?? "44ltcmhf7r8cti7u2fanuvk2tm",
        userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID ?? "us-east-1_1mePE2aSS"
      }
    }
  });


  const dispatch = useAppDispatch();
  const [connection, setConnection] = useState<null | signalR.HubConnection>(
    null
  );

  useEffect(() => {
    const connection = new signalR.HubConnectionBuilder()
      .withUrl(process.env.REACT_APP_API_URL + "/hubs")
      .configureLogging(signalR.LogLevel.Information)
      .build();
    setConnection(connection);
  }, []);

  useEffect(() => {
    if (connection) {
      connection
        .start()
        .then(() => {
          connection.on("SendUINotification", (message) => {
            fetchLatest();
          });
        })
        .catch((error) => console.log(error));
    }
  }, [connection]);

  const fetchLatest = async () => {
    const year = new Date().getFullYear();
    const month = new Date().getMonth();
    const startDate = new Date(year, month - 1, 1);
    const endDate = new Date(year, month + 2, 0);
    const params = {
      startDate,
      endDate,
    };
    await dispatch(getAppointment({ params }));
  };

  return (
    <ThemeProvider>
      <Routes />
    </ThemeProvider>
  );
};

export default App;
